// 全局前置的语言设置，不要引入其他依赖，防止影响执行顺序
export const prepareLanguage = () => {
    return new Promise<string>(res => {
        // 设置300ms的超时时间
        const timeout = setTimeout(() => {
            res('');
        }, 300);
        window.require(['framework'], (framework: any) => {
            clearTimeout(timeout);
            const currentLanguage = framework.i18n.getCurrentLanguage();
            if (currentLanguage !== localStorage.getItem('LANGUAGE')) {
                localStorage.setItem('LANGUAGE', currentLanguage);
            }
            res(currentLanguage);
        });
    });
};